import React, { useEffect, useState } from "react";
import axios from "axios";
import "../../../assets/styles/main.css";
import "../../../assets/styles/responsive.css";

const B2bFaqs = ({ toolName }) => {
  const [faqs, setFaqs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchFaqs = async () => {
      try {
        const response = await axios.post(
          "https://api.leadbud.io/frontend-api/faq-section",
          new URLSearchParams({ tool_name: toolName }),
          {
            headers: {
              "x-api-key": "034ea98da98113ef4c6b6cfc47618608",
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        );

        if (response.data && Array.isArray(response.data.faqs)) {
          setFaqs(response.data.faqs);
        } else {
          console.error("Invalid response format", response.data);
        }
      } catch (error) {
        console.error("Error fetching FAQs:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchFaqs();
  }, [toolName]);

  return (
    <div className="section home-faqs" style={{ marginTop: "0px", paddingTop: "0px" }}>
      <div className="container">
        <div className="content">
          <div className="content-area text-center">
            <h2 className="aos-item aos-init aos-animate">
              Frequently Asked Questions
            </h2>
            <div className="faq-para-wrapper">
              <p className="aos-item aos-init aos-animate">
                Discover clear and concise answers to your questions about
                Leadbud. Learn how to maximize your B2B prospecting efforts and
                make the most of your free 100 credits.
              </p>
            </div>
          </div>

          <div className="faqs-area" style={{ marginTop: "20px" }}>
            {loading ? (
              <p>Loading FAQs...</p>
            ) : (
              <div className="accordion" id="accordionExample">
                {faqs.length > 0 ? (
                  faqs.map((faq, index) => (
                    <div key={index} className="accordion-item aos-item aos-init aos-animate">
                      <h2 className="accordion-header" id={`heading${index}`}>
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target={`#collapse${index}`}
                          aria-expanded="false"
                          aria-controls={`collapse${index}`}
                        >
                          {index + 1}. {faq.question}
                        </button>
                      </h2>
                      <div
                        id={`collapse${index}`}
                        className="accordion-collapse collapse"
                        aria-labelledby={`heading${index}`}
                        data-bs-parent="#accordionExample"
                      >
                        <div className="accordion-body">
                          <p>{faq.answer}</p>
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <p>No FAQs available for this tool.</p>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default B2bFaqs;
